<template>
  <div class="bienvenida-page">
    <p class="versiculo-referencia-fija" ref="versiculoRef"></p>

    <!-- Curva superior izquierda -->
    <img 
      src="@/assets/curva.png" 
      alt="Curva superior izquierda" 
      class="decoracion-curva-top-left" 
    />

    <!-- Contenedor fecha estilo Save The Date -->
    <div class="fecha-evento" ref="fechaRef">
      
      <!-- Corona superior y líneas decorativas -->
      <div class="header-corona-wrapper" ref="coronaRef">
        <span class="linea-corona"></span>
        <img src="@/assets/corona.png" alt="Corona" class="corona-img" />
        <span class="linea-corona"></span>
      </div>

      <p class="fecha-gran-dia" ref="granDiaRef">
        SAVE THE DATE
      </p>

      <p class="fecha-dia-semana" ref="diaSemanaRef">Sábado</p>
      
      <p class="fecha-dia-numero" ref="numeroRef">10</p>
      
      <p class="fecha-mes" ref="mesRef">OCTUBRE</p>
      
      <!-- Año con líneas doradas a los lados -->
      <div class="anio-container" ref="anioRef">
        <span class="linea-dorada"></span>
        <span class="fecha-anio">2026</span>
        <span class="linea-dorada"></span>
      </div>

      <!-- Hora debajo de la fecha -->
      <p class="fecha-hora" ref="horaRef">4:00 PM</p>
    </div>

    <!-- Contenedor del separador: Curva 2 + Línea Dorada Divisoria -->
    <div class="separador-curva-container">
      <img 
        src="@/assets/curva2.png" 
        alt="Curva 2" 
        class="decoracion-curva2" 
      />
      <div class="linea-separadora-dorada"></div>
    </div>

    <!-- Contenido principal -->
    <div class="bienvenida-container">
      <div class="contenido-bienvenida">
        <div class="mensaje-bienvenida" ref="mensajeRef">
          {{ mensaje }}
        </div>
        <div class="versiculo-container" ref="versiculoTextRef">
          <p class="versiculo-texto">
            Hace&nbsp; <span class="letra-quince"> 15 años</span> comenzó mi historia, un viaje lleno de risas, aprendizajes y sueños compartidos.
            <br><br>
            Hoy, ese camino me trae hasta aquí, a este día tan especial donde celebro no solo mi vida, sino también el amor de quienes han estado conmigo en cada paso.
            <br>
          </p>
        </div>
      </div>
    </div>

    <!-- Decor.png pegado completamente a la esquina inferior derecha e invertido en X e Y -->
    <img 
      src="@/assets/decor.png" 
      alt="Decoración floral esquina" 
      class="decoracion-floral-esquina" 
    />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'BienvenidaPage',

  setup() {
    const mensaje = ref('');

    const coronaRef = ref(null);
    const granDiaRef = ref(null);
    const diaSemanaRef = ref(null);
    const numeroRef = ref(null);
    const mesRef = ref(null);
    const anioRef = ref(null);
    const horaRef = ref(null);
    const mensajeRef = ref(null);
    const versiculoTextRef = ref(null);
    const versiculoRef = ref(null);

    const animateOnScroll = (el, animationFn) => {
      if (!el || !(el instanceof Element)) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            animationFn();
            observer.unobserve(el);
          }
        },
        { threshold: 0.3 }
      );

      observer.observe(el);
    };

    onMounted(() => {
      // ANIMACIONES DE LA SECCIÓN FECHA
      animateOnScroll(coronaRef.value, () =>
        gsap.fromTo(
          coronaRef.value,
          { opacity: 0, scale: 0.5, y: -20 },
          { opacity: 1, scale: 1, y: 0, duration: 0.8, ease: 'back.out(1.7)' }
        )
      );

      animateOnScroll(granDiaRef.value, () =>
        gsap.fromTo(
          granDiaRef.value,
          { opacity: 0, y: 30 },
          { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out' }
        )
      );

      animateOnScroll(diaSemanaRef.value, () =>
        gsap.fromTo(
          diaSemanaRef.value,
          { opacity: 0, y: 20 },
          { opacity: 1, y: 0, duration: 0.8 }
        )
      );

      animateOnScroll(numeroRef.value, () =>
        gsap.fromTo(
          numeroRef.value,
          { opacity: 0, y: -60, scale: 0.8 },
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 1.1,
            ease: 'bounce.out'
          }
        )
      );

      animateOnScroll(mesRef.value, () =>
        gsap.fromTo(
          mesRef.value,
          { opacity: 0, y: 20 },
          { opacity: 1, y: 0, duration: 0.8 }
        )
      );

      animateOnScroll(anioRef.value, () =>
        gsap.fromTo(
          anioRef.value,
          { opacity: 0, scaleX: 0 },
          { opacity: 1, scaleX: 1, duration: 0.9, ease: 'power2.out' }
        )
      );

      animateOnScroll(horaRef.value, () =>
        gsap.fromTo(
          horaRef.value,
          { opacity: 0, y: 20, scale: 0.9 },
          { opacity: 1, y: 0, scale: 1, duration: 0.9, ease: 'back.out(1.5)', delay: 0.1 }
        )
      );

      animateOnScroll(mensajeRef.value, () =>
        gsap.fromTo(
          mensajeRef.value,
          { opacity: 0, y: 50 },
          { opacity: 1, y: 0, duration: 1 }
        )
      );

      animateOnScroll(versiculoTextRef.value, () =>
        gsap.fromTo(
          versiculoTextRef.value,
          { opacity: 0, y: 40 },
          { opacity: 1, y: 0, duration: 1 }
        )
      );

      animateOnScroll(versiculoRef.value, () =>
        gsap.fromTo(
          versiculoRef.value,
          { opacity: 0, y: 20 },
          { opacity: 1, y: 0, duration: 1 }
        )
      );
    });

    return {
      mensaje,
      coronaRef,
      granDiaRef,
      diaSemanaRef,
      numeroRef,
      mesRef,
      anioRef,
      horaRef,
      mensajeRef,
      versiculoTextRef,
      versiculoRef
    };
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@600;700&family=Great+Vibes&family=Playfair+Display:ital,wght@0,500;0,600;1,400;1,500&family=Poppins:wght@300;400&display=swap');

.bienvenida-page {
  background-color: #d8e9f3;
  background-image: 
    radial-gradient(circle at 50% 20%, rgba(255, 255, 255, 0.25) 0%, transparent 70%),
    linear-gradient(to bottom, rgba(0, 0, 0, 0.04) 0%, transparent 15%, transparent 85%, rgba(0, 0, 0, 0.08) 100%),
    repeating-linear-gradient(45deg, rgba(255, 255, 255, 0.03) 0px, rgba(255, 255, 255, 0.03) 1px, transparent 1px, transparent 3px),
    repeating-linear-gradient(135deg, rgba(0, 0, 0, 0.02) 0px, rgba(0, 0, 0, 0.02) 1px, transparent 1px, transparent 3px);

  color: #ffffff;
  min-height: 100vh;
  padding: 60px 0 0 0;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

/* CURVA SUPERIOR IZQUIERDA */
.decoracion-curva-top-left {
  position: absolute;
  top: 0;
  left: 0;
  width: 320px;
  max-width: 50vw;
  height: auto;
  pointer-events: none;
  z-index: 1;
}

/* CONTENEDOR CURVA 2 Y LÍNEA DIVISORIA DORADA */
.separador-curva-container {
  width: 100%;
  position: relative;
  margin-top: 10px;
  margin-bottom: 25px;
}

.decoracion-curva2 {
  width: 100%;
  height: auto;
  display: block;
  pointer-events: none;
  margin-bottom: -22px;
}

.linea-separadora-dorada {
  width: 85%;
  height: 1.5px;
  margin: -2px auto 0 auto;
  background: linear-gradient(90deg, transparent, #cba56b, transparent);
}

/* DECOR.PNG PEAGADO TOTALMENTE A LA ESQUINA INFERIOR DERECHA */
.decoracion-floral-esquina {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 200px;
  max-width: 40vw;
  height: auto;
  pointer-events: none;
  z-index: 2;
  transform: scale(-1, -1);
}

/* FECHA - ESTILO EDITORIAL IMAGEN */
.fecha-evento {
  text-align: center;
  margin: 0 auto 10px;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 3;
  padding: 0 20px;
}

/* CORONA Y LÍNEAS SUPERIORES */
.header-corona-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  margin-bottom: 5px;
}

.corona-img {
  width: 45px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0px 2px 3px rgba(0,0,0,0.15));
}

.linea-corona {
  height: 1.5px;
  width: 60px;
  background: linear-gradient(90deg, transparent, #cba56b, transparent);
}

/* SAVE THE DATE */
.fecha-gran-dia {
  font-family: 'Cinzel', 'Playfair Display', serif;
  font-size: 40px;
  font-weight: 700;
  line-height: 0.95;
  color: #4979a0;
  letter-spacing: 2px;
  margin: 5px 0 0 0;
  text-align: center;
}

/* SÁBADO (CURSIVA DORADA) */
.fecha-dia-semana {
  font-family: 'Great Vibes', 'Playfair Display', cursive, serif;
  font-size: 46px;
  color: #cba56b;
  margin: 0px 0 -10px 0;
  font-weight: 500;
}

/* NÚMERO 10 */
.fecha-dia-numero {
  font-family: 'Playfair Display', serif;
  font-size: 92px !important;
  font-weight: 500;
  font-style: italic;
  color: #4979a0;
  line-height: 0.95;
  margin: 0;
}

/* OCTUBRE */
.fecha-mes {
  font-family: 'Cinzel', 'Playfair Display', serif;
  font-size: 32px;
  font-weight: 700;
  color: #4979a0;
  letter-spacing: 4px;
  margin: 5px 0 10px 0;
}

/* AÑO CON LÍNEAS LATERALES */
.anio-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  width: 80%;
  margin-top: 2px;
}

.linea-dorada {
  height: 1.5px;
  flex: 1;
  background-color: #cba56b;
}

.fecha-anio {
  font-family: 'Playfair Display', serif;
  font-size: 24px;
  font-style: italic;
  color: #cba56b;
  font-weight: 500;
}

/* HORA 4:00 PM */
.fecha-hora {
  font-family: 'Playfair Display', serif;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 3px;
  color: #cba56b;
  margin-top: 15px;
  text-transform: uppercase;
}

/* CONTENIDO Y TEXTOS DE BIENVENIDA */
.bienvenida-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 3;
  padding: 0 20px 120px 20px;
}

.mensaje-bienvenida {
  font: 300 19px 'Josefin Sans', sans-serif;
  color: #000;
  white-space: pre-line;
  text-align: center;
  line-height: 2;
  opacity: 0;
}

.versiculo-container {
  margin: 10px 20px 0 20px;
  text-align: center;
  opacity: 0;
}

/* TEXTO DEL PÁRRAFO */
.versiculo-texto {
  font-family: 'Playfair Display', serif;
  font-size: 19px;
  font-style: italic;
  line-height: 1.8;
  color: #4979a0;
  margin-left: 0 !important;
  margin-right: 0 !important;
  text-align: center;
}

.versiculo-referencia-fija {
  font: 24px 'nombre', sans-serif;
  color: #ffffff;
  margin-top: 40px;
  opacity: 0;
}

.letra-quince {
  font-family: 'Great Vibes', cursive;
  font-size: 26px;
  color: #cba56b;
  letter-spacing: 1px;
  font-style: normal;
}
</style>